import axios from 'axios'

export const claims = {
    state: {
        claims: [],
        userclaimdetails: [],
        
    },
    mutations: {
        claims(state, data){
            state.claims = data.claims
        },
        userclaimdetails(state, data){
          state.userclaimdetails = data.members
        }

    },
    actions:{
      updateClaim: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
            axios.put("/claims", payload)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        getClaims: ({commit})=>{
            return new Promise((resolve, reject)=>{
                axios.get("/claims")
                .then(({status, data})=>{
                  if(status === 200){
                    resolve(data);
                    commit("claims", data)
                  }
                })
                .catch((error)=>{
                  reject(error);
                });
              })
        },
        getClaimsFilter: ({commit}, payload)=>{
          return new Promise((resolve, reject)=>{
            axios.get(`/claims?status=${payload.status}`)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("claims", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
        })
      },
        makePayment: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.get("/members?username="+payload)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("userclaimdetails", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        }

    }
}